import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendQueryPreviewUpgradeCostArgs,
  BackendUpgradeCostPreview,
} from 'src/types/backend';

const QUERY = gql`
  query PreviewUpgradeCost(
    $customerId: ID!
    $tier: String
    $plan: String
    $billingCycle: BillingCyclePeriod
    $promotionCode: String
  ) {
    previewUpgradeCost(
      customerId: $customerId
      tier: $tier
      plan: $plan
      billingCycle: $billingCycle
      promotionCode: $promotionCode
    ) {
      dueToday
      balanceAfterUpgrade
      currentBalance
    }
  }
`;

type Variables = BackendQueryPreviewUpgradeCostArgs;
type Result = BackendUpgradeCostPreview;

export const previewUpgradeCost = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
